module.exports = __webpack_public_path__ + "static/media/Graph.3c1909e5.svg";